import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                COMPLETED: "Completed",
                REQUIRED: "Required",
                CREATED: "Created",
                ['IN_PROGRESS']: "In Progress",
                common: {
                    "transitionJourney": "Transition Journey",
                    "aiAgent": "AI Agent",
                    "wingsAlly": "WINGS Ally",
                    "projectName": "Project Name",
                    dashboard: 'Dashboard',
                    dashboardCollaboration: 'Dashboard-Collaboration',
                    collaboration: 'Collaboration',
                    workLog: 'Work Log',
                    logout: 'Logout',
                    agentsInsights: 'Agents Insights',
                    projects: 'Projects',
                    save: 'Save',
                    cancel: 'Cancel',
                    proceed: 'Proceed',
                    close: 'Close',
                    yes: 'Yes',
                    no: 'No',
                    aiContentsDisclosure: 'Some content in this application is generated by AI and may not always be accurate. Please verify important information independently.',
                    chatAiDisclaimer: 'Responses are AI-generated and may not always be accurate. Please verify important information.',
                    showAIDisclosure: 'Show AI Disclosure',
                    hideAIDisclosure: 'Hide AI Disclosure',
                    backToLogin: 'Back to login',
                    notOnboardedMessage: 'Please contact your administrator to request access or update your permissions.',
                    doNotHavePermissions: "You don't have access to this application."
                },
                "mainMenu": {
                    "dashboard": "Dashboard",
                    "ktPlan": "KT Plan",
                    "data": "Data",
                    "transitionJourney": "Transition Journey",
                    "application": "Application",
                    "integration": "Integration",
                    "infraCloud": "Infra Cloud",
                    "security": "Security",
                    "network": "Network",
                    "businessFunctions": "Business Functions",
                    "itOps": "IT Ops"
                },
                chatHistory: {
                    recentChatHistoryTitle: "Recent Chats",
                    recentChatHistorySubtitle: "Showing data from the last {{days}} days",
                    loadingMoreChats: "Loading more chats...",
                    groupToday: "Today",
                    groupYesterday: "Yesterday",
                    groupThisWeek: "This Week",
                    groupThisMonth: "This Month",
                    groupLastMonth: "Last Month",
                    groupOlder: "Older",
                },
                ticketStatus: {
                    title: "TICKET STATUS",
                    searchLabel: "Search",
                    noDataFound: "No data found",
                    loadingMoreTickets: "Loading more tickets...",
                    viewMore: "View More",
                },
                transitionJourney: {
                    correctAnswer: 'Correct Answer',
                    yourAnswer: 'Your Answer',
                    correct: 'Correct',
                    incorrect: 'Incorrect',
                    assessmentParamsSelector: {
                        title: 'Assessment Params Selector',
                        subtitle: 'Choose App Type, App Name and Role',
                        appTypeLabel: 'App Type',
                        appNameLabel: 'App Name',
                        roleLabel: 'Role',
                        placeholder: 'Search...',
                        noOptions: 'No matches',
                        changeLanguage: 'Change language',
                        doneButtonLabel: 'Done',
                        selectedParams: 'Selected',
                        selectAssessmentParams: 'Select Assessment Parameters'
                    },
                    errorBoundary: {
                        somethingWrong: 'Something went wrong',
                        errorDetails: 'Error Details',
                        name: 'Name:',
                        message: 'Message:',
                        stack: 'Stack:',
                        retry: 'Retry',
                    },
                    overview: 'Overview',
                    prerequisites: "Configuration",
                    teamCollaboration: "Team Invitation",
                    connectors: "Connectors",
                    noMembers: "No Members",
                    smartCausalConfig: "Hotspot Analysis",
                    teamCollaborationProgress: "Team Collaboration Progress",
                    teamCollaborationNotes: "Team Collaboration Notes",
                    collaborationLogs: "Collaboration Logs",
                    configureKnowledge: "Configure Knowledge",
                    knowledgeConfigurationProgress: "Knowledge Configuration Progress",
                    knowledgeConfigurationNotes: "Knowledge Configuration Notes",
                    configurationLogs: "Configuration Logs",
                    autoCreateStandardDirectory: "Auto Create Standard Directory",
                    directoryCreationProgress: "Directory Creation Progress",
                    directoryCreationNotes: "Directory Creation Notes",
                    directoryLogs: "Directory Logs",

                    learn: "Learn",
                    deriveKnowledge: "Knowledge Artifacts",
                    knowledgeDerivationProgress: "Knowledge Derivation Progress",
                    knowledgeDerivationNotes: "Knowledge Derivation Notes",
                    derivationLogs: "Derivation Logs",
                    automatedTicketAnalysis: "Tickets Analysis",
                    reviewAssessment: "Review Assessment",
                    ticketAnalysisProgress: "Ticket Analysis Progress",
                    ticketAnalysisNotes: "Ticket Analysis Notes",
                    analysisLogs: "Analysis Logs",
                    autoCreateAdditionalFolder: "Auto Create Additional Folder",
                    folderCreationProgress: "Folder Creation Progress",
                    folderCreationNotes: "Folder Creation Notes",
                    creationLogs: "Creation Logs",
                    generateDetailedQuestionnaire: "Generate Detailed Questionnaire",
                    questionnaireGenerationProgress: "Questionnaire Generation Progress",
                    questionnaireNotes: "Questionnaire Notes",
                    generationLogs: "Generation Logs",

                    knowledgeWorkflow: "Knowledge Workflow & KT Session",
                    itManagerKnowledgeWorkflow: "Knowledge Workflow",
                    knowledgeCoverageAssessment: "Knowledge Assessment",
                    sopGeneration: "SOP Generation",
                    sopGenerationProgress: "SOP Generation Progress",
                    sopGenerationNotes: "SOP Generation Notes",
                    serviceRequestGeneration: "Service Request Generation",
                    serviceRequestGenerationProgress: "Service Request Generation Progress",
                    serviceRequestNotes: "Service Request Notes",
                    requestLogs: "Request Logs",
                    identifyGaps: "Identify Gaps",
                    gapIdentificationProgress: "Gap Identification Progress",
                    gapIdentificationNotes: "Gap Identification Notes",
                    identificationLogs: "Identification Logs",
                    knowledgeTransitionPlan: "Knowledge Transition Plan",
                    generatingQuestions: "Generating Questions",
                    questionGenerationProgress: "Question Generation Progress",
                    questionGenerationNotes: "Question Generation Notes",
                    generatingKtPlan: "Generating KT Plan",
                    ktPlanGenerationProgress: "KT Plan Generation Progress",
                    ktPlanGenerationNotes: "KT Plan Generation Notes",
                    reviewKtPlan: "KT Topics",
                    ktPlanReviewProgress: "KT Plan Review Progress",
                    ktPlanReviewNotes: "KT Plan Review Notes",
                    reviewLogs: "Review Logs",
                    publishKtPlan: "Publish KT Plan",
                    ktPlanPublishingProgress: "KT Plan Publishing Progress",
                    ktPlanPublishingNotes: "KT Plan Publishing Notes",
                    publishingLogs: "Publishing Logs",
                    schedulingKtSession: "Scheduled KT Sessions",
                    ktSessionSchedulingProgress: "KT Session Scheduling Progress",
                    ktSessionSchedulingNotes: "KT Session Scheduling Notes",
                    schedulingLogs: "Scheduling Logs",

                    ktSession: "KT Sessions",
                    ktSessions: "KT Sessions",
                    updateKtSession: "Update KT Session",
                    addKtSession: "Add KT Session",
                    updatePlaybackSession: "Update Playback Session",
                    addPlaybackSession: "Add Playback Session",
                    update: "Update",
                    add: "Add",
                    ktStatus: 'KT Status',
                    ktUpdateWarning: 'Please ensure all the KT recordings are uploaded before you complete the KT status. Once Status changes to  Completed, no KT Recordings can be uploaded.',
                    ktReview: 'KT Review',
                    ktSessionMessages: {
                        descriptionRequired: 'Description is required',
                        videoPathRequired: 'Video path is required',
                        statusRequired: 'Status is required',
                        projectIdMissing: 'Project ID is missing. Cannot {{action}} KT Session.',
                        updateSuccess: 'KT Session updated successfully',
                        addSuccess: 'KT Session added successfully',
                        updateError: 'Error updating KT Session',
                        addError: 'Error adding KT Session',
                        videoPathRequiredForCompleted: 'For status completed, kt video path must be updated with new recording path',
                        descriptionPlaceholder: 'Enter session description',
                        videoPathPlaceholder: 'Enter the video path URL',
                        descriptionHelperText: 'Provide a detailed description of the KT session',
                        videoPathHelperText: 'Enter the complete path or URL to the KT session video'
                    },
                    processKtVideo: "Process KT Video",
                    videoLink: "Video Link",
                    videoAnalysisStatus: "Video Analysis Status",
                    failedReason: 'Failed Reason: ',
                    runVideoAnalysis: 'Run Video Analysis',
                    videoAnalysisNote: 'Note: MP4 and MKV files are supported. Other video format files will be ignored.',
                    continueProceed: 'Do you want to proceed ?',
                    ktVideoProcessingProgress: "KT Video Processing Progress",
                    ktVideoProcessingNotes: "KT Video Processing Notes",
                    processingLogs: "Processing Logs",
                    prepareDocument: "Prepare Document",
                    documentPreparationProgress: "Document Preparation Progress",
                    documentPreparationNotes: "Document Preparation Notes",
                    preparationLogs: "Preparation Logs",
                    performQualityCheck: "Perform Quality Check",
                    qualityCheckProgress: "Quality Check Progress",
                    qualityCheckNotes: "Quality Check Notes",
                    qualityCheckLogs: "Quality Check Logs",
                    generateSopDocument: "Generate SOP Document",
                    sopDocumentGenerationProgress: "SOP Document Generation Progress",
                    sopDocumentNotes: "SOP Document Notes",
                    sopDocumentLogs: "SOP Document Logs",
                    playback: "Playback",
                    playbackSessions: 'Playback Sessions',
                    playbackAssessment: 'Playback Assessment',
                    reverseKtSession: "Reverse KT Session",
                    processReverseKtVideo: "Process Reverse KT Video",
                    reverseKtVideoProcessingProgress: "Reverse KT Video Processing Progress",
                    reverseKtVideoNotes: "Reverse KT Video Notes",
                    generateMcq: "Generate MCQ",
                    mcqGenerationProgress: "MCQ Generation Progress",
                    mcqGenerationNotes: "MCQ Generation Notes",
                    shareCertificationToCustomer: "Share Certification to Customer",
                    certificationSharingProgress: "Certification Sharing Progress",
                    certificationSharingNotes: "Certification Sharing Notes",
                    sharingLogs: "Sharing Logs",
                    reverseKtToCustomer: "Reverse KT to Customer",
                    reverseKtToCustomerProgress: "Reverse KT to Customer Progress",
                    reverseKtToCustomerNotes: "Reverse KT to Customer Notes",
                    reverseKtLogs: "Reverse KT Logs",

                    smtdGeneration: "SMTD Generation",
                    generateSmtd: "Generate SMTD",
                    smtdGenerationProgress: "SMTD Generation Progress",
                    smtdGenerationNotes: "SMTD Generation Notes",
                    reviewSmtd: "SMTD Review",
                    smtdReviewProgress: "SMTD Review Progress",
                    smtdReviewNotes: "SMTD Review Notes",
                    transitionClosure: "Transition Closure",
                    transitionStatusReport: "Transition Status Report",
                    transitionReview: 'Transition Review',
                    transitionStatusReportProgress: "Transition Status Report Progress",
                    transitionStatusReportNotes: "Transition Status Report Notes",
                    reportLogs: "Report Logs",
                    closureAndSignOff: "Closure and Sign Off",
                    closureAndSignOffProgress: "Closure and Sign Off Progress",
                    closureAndSignOffNotes: "Closure and Sign Off Notes",
                    closureLogs: "Closure Logs",

                    description: 'Description',
                    videoPath: 'Video Path',
                    viewStatus: 'Status',
                    overallStatus: 'Overall Status',
                    overallKtStatus: 'Overall KT Status',
                    overallPlaybackStatus: 'Overall Playback Status',
                    updateKtStatus: 'Update KT Status',
                    updatePlaybackStatus: 'Update Playback Status',
                    videoAnalysisSummary: 'Video Analysis Summary',
                    viewDocument: 'View Document',
                    downloadVideoAnalysisDoc: 'Download Video Analysis Document',
                    downloadComparisonDoc: 'Download Video Comparison Document',
                    updateStatus: 'Update Status',
                    source: 'Source',
                    updatedAt: 'Updated At',
                    play: 'Play',

                    createProject: 'Create Project',
                    projectDetails: 'Project Details',
                    inviteMember: 'Invite Member',
                    searchName: 'Search name here',
                    projectName: 'Name',
                    projectDescription: 'Description',
                    projectStartDate: 'Start Date',
                    projectEndDate: 'End Date',
                    projectPlanUpload: 'Project Plan Upload',
                    value: 'Value',
                    activeAgentTasks: "Active Agent Tasks",
                    workflowLogs: "Workflow Logs",
                    createNewProject: 'Create New Project',
                    projectNameRequired: 'Project Name Required',
                    projectDescriptionRequired: 'Project Description Required',
                    projectStartDateRequired: 'Project Start Date Required',
                    projectEndDateRequired: 'Project End Date Required',
                    endDateAfterStartDate: 'Project End Date should be after Start Date',
                    projectPlanRequired: 'Project Plan upload Required',
                    selfRemovedFromProject: 'You have been removed from this project. Redirecting to dashboard.',
                    "search": "Search",
                    "addUser": "Add User",
                    "newMembers": "New Members",
                    "existingMembers": "Existing Members",
                    "listOfProjects": "List of Projects",
                    "members": "Members",
                    "addMore": "Add More",
                    "addMembers": "Add Members",
                    "noProjectPlanUploaded": "No project plan uploaded",
                    "noProcessedConnector": "Transition (data processing) is not initiated yet.",
                    "process": "Process",
                    "reprocess": "Reprocess",
                    journeyDashboard: {
                        projectsProgress: "Projects Progress",
                        ktSessions: "KT Sessions",
                        agentPerformance: {
                            title: "Agent Performance",
                            totalTasks: "Total Tasks",
                            successfulTasks: "Successful Tasks",
                            failedTasks: "Failed Tasks",
                            successRate: "Success Rate (%)",
                            avgResponseMs: "Latency (ms)",
                            avgResponseSec: "Latency (s)",
                            avgInputTokens: "Average Input Tokens",
                            avgOutputTokens: "Average Output Tokens",
                            totalInputTokens: "Total Input Tokens",
                            totalOutputTokens: "Total Output Tokens",
                            totalModelCost: "Total Model Cost (USD)",
                            avgModelCost: "Average Model Cost (USD)",
                            modelsUsed: "Models Used",
                            all: "All",
                            from: "From",
                            to: "To",
                            loading: "Loading agent performance data...",
                            errorTitle: "Failed to fetch agent summary",
                            tryAgain: "Retry"
                        },
                        modelCosts: {
                            title: "Model Details",
                            loading: "Loading model costs...",
                            errorTitle: "Failed to load model costs",
                            retry: "Retry",
                            modelName: "Model Name",
                            totalCost: "Total Cost ($)",
                            totalTokens: "Total Tokens",
                            observations: "Observations",
                            avgLatency: "Avg Latency (s)",
                            uniqueModels: "Unique Models",
                            totalObservations: "Total Observations",
                            summaryTotalTokens: "Total Tokens",
                            summaryTotalCost: "Total Cost ($)",
                            allAgents: "All Agents"
                        }
                    },
                    agentTraces: {
                        title: "Agent Traces",
                        allAgents: "All Agents",
                        showingTraces: "Showing {{count}} traces",
                        loadingMore: "Loading more...",
                        loadingTraces: "Loading traces...",
                        failedToLoad: "Failed to Load Traces",
                        retry: "Retry",
                        noTracesFound: "No Traces Found",
                        allTracesLoaded: "All traces loaded",
                        timestamp: "Timestamp",
                        name: "Name",
                        input: "Input",
                        output: "Output",
                        observationLevels: "Observations Levels",
                        latency: "Latency",
                        environment: "Environment",
                        metadata: "Metadata",
                        view: "View",
                        loadingMoreTraces: "Loading more traces...",
                    },
                    traceDetails: {
                        title: "Trace Details",
                        executionTree: "Execution Tree",
                        preview: "Preview",
                        logView: "Log View",
                        formatted: "Formatted",
                        json: "JSON",
                        input: "Input",
                        output: "Output",
                        tags: "Tags",
                        metadata: "Metadata",
                        path: "Path",
                        value: "Value",
                        emptyString: "empty string",
                        noMetadataAvailable: "No metadata available",
                        noObservationsAvailable: "No observations available",
                        noChildObservations: "No child observations",
                        selectNodeToView: "Select a node from the execution tree to view details",
                        session: "Session",
                        userId: "User ID",
                        env: "Env",
                        latency: "Latency",
                        items: "items",
                        item: "item",
                        concatenatedObservationLog: "Concatenated Observation Log",
                        copyToClipboard: "Copy to clipboard",
                        copyId: "Copy ID",
                        refresh: "Refresh",
                        close: "Close",
                        copiedToClipboard: "Copied to clipboard",
                        failedToCopyToClipboard: "Failed to copy",
                        failedToLoadTraceDetails: "Failed to load trace details",
                        retry: "Retry",
                        id: "id",
                        type: "type",
                        name: "name",
                        startTime: "startTime",
                        endTime: "endTime",
                        level: "level",
                        parentObservationId: "parentObservationId",
                        noTags: "No tags"
                    },
                    agentQuality: {
                        metricsTable: {
                            title: "Metrics Table",
                            noDataAvailable: "No {{type}} Available",
                            selectAgent: "Select an Agent",
                            selectDate: "Select Date",
                            loadingMetrics: "Loading metrics for {{agentName}}...",
                            failedToLoad: "Failed to fetch metric data",
                            failedToLoadFor: "Failed to load data for {{agentName}}",
                            pleaseSelectAgent: "Please select an agent to view metrics.",
                            noMetricsAvailable: "No metrics data available for {{agentName}}.",
                            score: "Score: {{score}}",
                            viewContext: "View Context",
                            viewPrompt: "View Prompt",
                            viewResponse: "View Response",
                            viewSummary: "View Summary",
                            viewUserInput: "View User Input",
                            close: "Close",
                            formattedView: "Formatted View",
                            rawJSON: "Raw JSON",
                            context: "Context",
                            prompt: "Prompt",
                            agentResponse: "Agent Response",
                            summary: "Summary",
                            userInput: "User Input"
                        }
                    },
                    traceGraph: {
                        executionGraph: "Execution Flow",
                        zoomIn: "Zoom In",
                        zoomOut: "Zoom Out",
                        resetView: "Reset View"
                    },
                    createEditProject: {
                        "createProject": 'Create Project',
                        "projectDetails": "Project Details",
                        "projectLabel": "Name",
                        "editProjectTooltip": "Edit Project",
                        "deleteProjectTooltip": "Delete Project",
                        "projectName": 'Name',
                        "projectDescription": "Description",
                        "projectNamePlaceholder": "Enter project name",
                        "projectNameCannotBeEmpty": "Project name cannot be empty",
                        "projectDescriptionPlaceholder": "Enter project description",
                        "projectPlanPlaceholder": "Upload project plan sheet",
                        "uploadProjectPlanTooltip": "Upload project plan",
                        "projectStartDate": "Start Date",
                        "projectEndDate": "End Date",
                        "projectPlan": "Project Plan",
                        "downloadProjectPlanTooltip": "Download Project Plan",
                        "update": "Update",
                        "cancel": "Cancel",
                        "create": "Create",
                        "deleteProjectTitle": "Delete Project",
                        "deleteProjectConfirm": "Are you sure you want to permanently delete the Project: {{projectName}}?",
                        "deleteProjectWarning": "This action cannot be undone. All project related data will be lost and cannot be recovered.",
                        "delete": "Delete",
                        "projectOwner": "Project Owner",
                        projectWorkLogsTitle: 'Project Work Logs',
                        TeamMembersWorkLogsTitle: 'Team Members Work Logs',
                        "transitionDirector": "Transition Director(s)",
                        "transitionManager": "Transition Manager(s)",
                        "projectUpdatedSuccessfully": "Project updated successfully",
                        "roleAddedFor": "Role added for {{memberName}}: {{roles}}",
                        "rolesAddedFor": "Roles added for {{memberName}}: {{roles}}",
                        "memberAddedAs": "Member Added: {{memberName}} as {{roles}}",
                        "memberAdded": "Member Added: {{memberName}}",
                        "memberRemoved": "Member Removed: {{memberName}}",
                        "membersRemoved": "Members Removed: {{memberNames}}",
                        "roleRemovedFor": "Role removed for {{memberName}}: {{roles}}",
                        "rolesRemovedFor": "Roles removed for {{memberName}}: {{roles}}",
                        "unknownError": "Unknown error",
                        "errorUpdatingProject": "Error updating project",
                    },
                    teamInvite: {
                        "title": "Team Members",
                        "subtitle": "Add new or remove existing members",
                        "searchPlaceholder": "Search and add members",
                        "bulkUploadButton": "Bulk Add",
                        "addUserButton": "Add User",
                        "assignButton": "Onboard",
                        "newMembers": "New Members",
                        "roleNotSelected": "Role not selected",
                        "selectRole": "Select Role",
                        "inviteButton": "Assign to the project",
                        "selectRolesFor": "Select roles for {{count}} member",
                        "selectRolesFor_plural": "Select roles for {{count}} members",
                        "memberHasAllRoles": "{{count}} member already has all roles, please clear member to proceed",
                        "memberHasAllRoles_plural": "{{count}} members already have all roles, please clear those members to proceed",
                        "toInvite": " to onboard",
                        "existingTeamMembers": "Existing Team Members",
                        "workLog": "Work Log",
                        "workLogTitle": "Work log for sending invitation",
                        "alreadyAdded": "Already added",
                        "addMember": "Add member",
                        "removeMember": "Remove member",
                        "clearMember": "Clear",
                        "uploadFromFile": "Upload members from file",
                        "addNewUser": "Add new user",
                        "invited": "Onboarded",
                        "role": "Role",
                        "confirmRemoveTitle": "Remove Team Member",
                        "confirmRemoveMessage": "Are you sure you want to remove member",
                        "confirmRemoveSubtext": "This action cannot be undone. The member will lose access to this project.",
                        "removeConfirmationWarning": "This action cannot be undone.",
                        "memberWillLoseAccessSelectedRoles": "The member will lose access to resources for the selected roles.",
                        "memberWillLoseAccessAllResources": "The member will lose access to all team resources.",
                        "selectRolesToRemove": "Select Roles to Remove",
                        "hasMultipleRolesSelectToRemove": "has multiple roles. Select which roles to remove:",
                        "cancel": "Cancel",
                        "remove": "Remove",
                        "noNewMembers": "No New Members Added",
                        "noNewMembersDescription": "Start by adding team members to begin collaboration.",
                        "noExistingMembers": "No Existing Team Members Yet",
                        "noTeamMembersDescription": "Start adding team members into your project.",
                        "noExistingMembersDescription": "Team members who have already been added to this project will appear here.",
                        "noTeamMembers": "No Team Members Yet",
                        "bulkAddTitle": "Bulk Add Members",
                        "bulkUploadNote": "Note: you are allowed to add 'Transition Directors' and other 'Transition Admins'. Once you have filled the sheet, upload it back here.",
                        "browseButton": "Browse",
                        "downloadSampleTemplate": "Download Sample Template",
                        "downloading": "Downloading...",
                        "uploadPlaceholder": "Upload user detail sheet",
                        "supportedFormats": "Supported formats: {{formats}}",
                        "uploadUserDetails": "Upload User Details",
                        "uploading": "Uploading...",
                        "uploadSuccessToast": "Users added in bulk with assigned roles.",
                        "uploadErrorToast": "Failed to upload file. Please try again.",
                        "clear": "Clear",
                        "memberAddedAutoClear": "Member added successfully",
                        "membersAddedAutoClear_plural": "Members added successfully",
                        "searchResultsCount": "Showing {{showing}} of {{total}} results",
                        "loadingMore": "Loading more...",
                        "loadMore": "Load {{remaining}} more results",
                        "searching": "Searching...",
                        "minimumCharacters": "Enter at least 2 characters to search",
                        "noUsersFound": "No users found for this search",
                        "startTyping": "Start typing to search for users",
                        "browse": "Browse",
                        "upload": "Upload",
                        "fileFormatNotSupported": "File format is not supported. Please upload a file with one of the following formats: {{formats}}",
                        "selfAdd": "You are already part of the team.",
                        "duplicateEmail": "Duplicate email found. This email was already mentioned on line {{line}}.",
                        "existingMember": "Email already exists as a team member.",
                        "existingMemberRole": "This email-role combination already exists as a team member.",
                        "invalidRole": "You cannot assign the role \"{{role}}\". Allowed roles: {{allowed}}.",
                        "invalidEmailFormat": "Invalid email format.",
                        "roleRequired": "Role is required.",
                        "csvParseFailed": "Failed to parse CSV file.",
                        "csvParseError": "CSV parsing error: {{error}}",
                        "roleNotAllowed": "Role '{{role}}' is not allowed.",
                        "bulkUploadResults": "Bulk Upload Results",
                        "bulkUploadProcessed": "Bulk Upload Processed",
                        "teamUpdateResults": "Skipped Team Members Update Results",
                        "selectAll": "Select All",
                        "selectAllWarningCreate": "Selecting all roles will completely remove this member from the system.",
                        "selectAllWarningEdit": "Selecting all roles will revoke this member's access to the project entirely.",
                        "allRolesRemovedWarning": "Member will be removed on update.",
                        "selectPersona": "Select Persona",
                        "continue": "Continue",
                        "confirmRemoveQuestion": "Are you sure you want to remove",
                        "fromSelectedRoles": "from the selected roles",
                        "fromTheTeam": "from the team",
                        "rolesToBeRemoved": "Roles to be removed:",
                        "removing": "Removing...",
                        "removeMemberButton": "Remove Member",
                        "successfullyAdded": "Successfully Added ({{count}})",
                        "skippedMembers": "Skipped Members ({{count}})",
                        "showLess": "Show Less",
                        "showAll": "Show All",
                        "memberAddedSuccessfully": "Member added successfully",
                        "entriesProcessedSummary": "{{total}} entries processed • {{added}} member{{addedPlural}} added • {{skipped}} skipped",
                        "membersProcessedSummary": "{{total}} members processed • {{added}} added • {{skipped}} skipped",
                    },
                    smartCausal: {
                        common: {
                            downloadSuccess: "Downloaded successfully!",
                            downloadError: "Downloading Failed"
                        },
                        cards: {
                            platformHotspots: "Platform Hotspots",
                            observations: "Observations",
                            comparisons: "Comparisons",
                            report: "Report",
                            dataSource: "Data Source",
                            viewsDisabledTooltip: "Options will be available after a successful analysis."
                        },
                        config: {
                            heading: "Hotspot Analysis Configuration",
                            selectDataSource: "Select Data Source",
                            selectConnector: "Select Connector",
                            selectDirectory: "Select Directory",
                            selectDateRange: "Select Date Range",
                            sharepoint: "SharePoint",
                            servicenow: "ServiceNow",
                            googleWorkspace: "Google Workspace",
                            loadingConnectorDetails: "Loading connector details...",
                            showingConnectorsWithMore: "Showing {{count}} connectors, more available...",
                            failedToLoadConnectors: "Failed to load connectors",
                            selectConnectorPlaceholder: "Select a connector",
                            noConnectorsAvailable: "No Sharepoint connectors mapped to this project.",
                            noServiceNowConnectorsAvailable: "No Servicenow connectors mapped to this project.",
                            noGoogleWorkspaceConnectorsAvailable: "No Google Workspace connectors mapped to this project.",
                            noDirectoriesAvailable: "No directories available for this connector",
                            selectDirectoryPlaceholder: "Select a directory path",
                            from: "From",
                            to: "To",
                            save: "Save Configuration",
                            saving: "Saving...",
                            cancel: "Cancel",
                            name: "Name:",
                            type: "Type:",
                            directories: "Directories:",
                            updatedAt: "Updated At:",
                            clickToViewAllConnectors: "Click the card again to view all available connectors",
                            showingConnectors: "Showing {{count}} connectors - scroll for more",
                            showingAllConnectors: "Showing all - {{count}} {{source}} connectors",
                            downloadTemplate: "Download Template",
                            downloadTemplateTooltip: "Download Sample Template",
                            downloading: "Downloading...",
                            templateInfoMessage: "Please follow the template consistently and ensure the <strong>Created Date</strong> and <strong>Closed Date</strong> use the same date format across all columns/rows (eg: <strong>mm/dd/yyyy hh:mm</strong>).",
                        },
                        analysisRunner: {
                            startRun: "Start Run",
                            selectDateRange: "Select Date Range",
                            loadingConfiguration: "Loading configuration...",
                            fromDate: "From Date",
                            toDate: "To Date",
                            clear: "Clear",
                            running: "Running...",
                            run: "Run",
                            reRun: "Re-run",
                            reRunConfirmTitle: "Confirm Re-run",
                            reRunConfirmMessage: "The re-run will replace the previous analysis. Do you want to continue with re-running the analysis?",
                            selectBothDates: "Please select both From and To dates",
                            fromDateBeforeToDate: "From date must be before To date",
                            toDateNotFuture: "To date cannot be in the future",
                            analysisFailedGeneral: "Failed to run analysis. Please try again.",
                            analysisFailedNoResponse: "Analysis failed - no response received",
                            failedToLoad: "Failed to load configuration. Please try again."
                        },
                        mindmap: {
                            hotspotMindmap: "Platform Hotspot Mindmap",
                            loadingMindmap: "Loading platform hotspots...",
                            runningAnalysis: "Running analysis... This may take 8-10 minutes.",
                            exportMindmap: "Download Mindmap",
                            exporting: "Exporting...",
                            exportTitle: "Platform Hotspot Mind Map",
                            generatedOn: "Generated on:",
                            noDataAvailable: "No data available",
                            analysisInProgress: "Analysis in Progress",
                            runInProgress: "Run is In Progress",
                            processDuration: "This process may take some time depending on the data for processing. Please check the worklogs for the progress.",
                            navigateAwayMessage: "You can safely navigate away and return later to check the results.",
                            analyzingDataFor: "Analyzing data for:",
                            analysisInProgressMsg: "This may take 8-10 minutes. You can safely navigate away and return later to check the results.",
                            created: "Created:",
                            displayHotspotsMsg: "Unable to display Platform Hotspots",
                            mindMapnotloadingMsg: "The mindmap could not be loaded. Please try running the analysis again.",
                            loadingError: "Failed to fetch mindmap data. Please try again later.",
                            retry: "Retry",
                            proceed: "Proceed",
                            analysisFailedTitle: "Last Run Failed",
                            analysisFailedMessage: "An error occurred while running the analysis. The system was unable to complete the mind map generation.",
                            failedAnalysisPeriod: "Failed Analysis Period:",
                            tryAgainMessage: "Please try running the analysis again with the same or different date range.",
                            noRecordsFoundTitle: "No Records Found",
                            errorReason: "Reason:",
                            noRecordsFoundMessage: "There are no records available for this project.",
                            noRecordsFoundSuggestion: "Try running a new analysis using the 'Run Analysis' button above to generate insights for your project.",
                            panLeft: "Pan left",
                            panUp: "Pan up",
                            panDown: "Pan down",
                            panRight: "Pan right",
                            zoomOut: "Zoom out",
                            zoomIn: "Zoom in",
                            reset: "Reset"
                        },
                        observations: {
                            title: "Observations",
                            networkFailure: "Network Resource Failure",
                            networkOutage: "Network Resource Outage",
                            ObservationsTable: "Observations Table",
                            downloadTableTooltip: "Download Observation Table",
                            downloadTopicFilters: "Download Topic Filters",
                            ObservationTableError: "ObservationTable: {{error}}",
                            errorTitle: "Unable to load observations data",
                            mainClustersError: "Failed to load main clusters: {{error}}",
                            mainClustersErrorDescription: "The main clusters could not be loaded due to API connectivity issues or no data being available. Please try again later or contact support if the problem persists.",
                            apiError: "API Error: {{error}}. Unable to load observations data.",
                            loadingObservations: "Loading observations data...",
                            observationTableError: "Failed to load observation table data",
                            retry: "Retry",
                            topicFilters: "Topic Filters",
                            selectMainCluster: "Select Main Cluster",
                            selectSubCluster: "Select Sub Cluster",
                            chooseMainClusterPlaceholder: "Choose main cluster...",
                            chooseSubClusterPlaceholder: "Choose sub cluster...",
                            loadingObservationsData: "Loading observations data...",
                            loadingClusters: "Loading clusters...",
                            fetchingIncidentData: "Please wait while we fetch the latest data",
                            loadingAvailableClusters: "Please wait while we load available clusters",
                            selectBothClusters: "Please select both Main Cluster and Sub Cluster",
                            dataDisplayedAfterSelection: "Data will be displayed once both selections are made",
                            downloadProcessedFile: "Download Processed Data",
                            downloadAnamoliesFile: "Download Anomalies Data",
                            downloadUnprocessedData: "Download Unprocessed Data",
                            noFileAvailable: "No processed file available for download",
                            fileDownloadSuccess: "File downloaded successfully",
                            fileDownloadError: "Failed to download file. Please try again.",
                            downloadClusteringFile: "Download Clustered Data",
                            noClusteringFileAvailable: "No clustered file available for download",
                            clusteringFileDownloadSuccess: "Clustered file downloaded successfully",
                            clusteringFileDownloadError: "Failed to download clustered file. Please try again.",
                            downloading: "Downloading...",
                            incidentsChart: {
                                title: "Incidents by Month",
                                subtitle: "Timeline analysis of incidents",
                                dailyIncidents: "Daily Incidents",
                                highNoIncidents: "High Number of Incidents",
                                incidents: "Incidents",
                                highIncidentDay: "High Incident Day",
                                date: "Date",
                                incidentCount: "Incident Count",
                                noTimeLineData: "No timeline data available from API",
                                dataisStillLoading: "Select both main cluster and sub cluster to view incident timeline"
                            },
                            impact: {
                                impactTitle: 'Impact',
                                noImpactData: 'No impact data available'
                            },
                            smartInsights: {
                                loadingInsights: "Loading insights...",
                                title: "Smart Causal Insights",
                                downloadInsightsTooltip: "Download Insights",
                                noInsights: "No insights available"
                            },
                            solutionSteps: {
                                loadingSolutionSteps: "Loading Solution Steps...",
                                title: "Solution Steps",
                                downloadSolutionStepsTooltip: "Download Solution Steps",
                                dataisStillLoading: "Select both main cluster and sub cluster to view solution steps"
                            },
                            sop: {
                                loadingSOP: "Loading SOP...",
                                title: "Standard Operating Procedures",
                                sop: "SOP",
                                downloadSOPTooltip: "Download SOP",
                                objective: "Objective:",
                                steps: "Steps:",
                                dataisStillLoading: "Select both main cluster and sub cluster to view SOP"
                            },
                            table: {
                                headers: {
                                    serialNumber: "S.No",
                                    index: "Index",
                                    assignmentGroup: "Assignment Group",
                                    mainCluster: "Main Cluster",
                                    subCluster: "Sub Cluster",
                                    count: "Count",
                                    incident: "Incident",
                                    incidentCreatedOn: "Incident Created On",
                                    priority: "Priority",
                                    impact: "Impact",
                                    urgency: "Urgency",
                                    ticketTitle: "Ticket Title",
                                    description: "Description"
                                }
                            },
                            pieChart: {
                                loadingCharts: "Loading charts...",
                                noAssignmentMessage: "No assignment group data available",
                                selectBothClustersforPieChart: " Select both main cluster and sub cluster to view assignment group chart"
                            }
                        },
                        comparisons: {
                            title: "Comparisons",
                            loading: "Loading comparison data...",
                            retry: "Retry",
                            loadingMetrics: "Loading metrics...",
                            totalIncidentsProcessed: "Total Incidents Processed",
                            totalIncidentsClustered: "Total Incidents Clustered",
                            totalUniqueMainClusters: "Total Number of Unique Main Clusters",
                            totalUniqueSubClusters: "Total Number of Unique Sub Clusters",
                            totalIncidentsMllm: "Total Incidents - Latest Month (Main Cluster)",
                            totalIncidentsLlm: "Total Incidents - Latest Month (Sub Cluster)",
                            tooltipMllm: "This shows the percentage change in total mLLM-categorized incidents between the first and most recent periods.",
                            tooltipMllmIncrease: "An increase indicates more incidents in recent period.",
                            tooltipMllmDecrease: "A decrease indicates fewer incidents in recent period.",
                            tooltipLlm: "This shows the percentage change in total LLM-categorized incidents between the first and most recent periods.",
                            tooltipLlmIncrease: "An increase indicates more incidents in recent period.",
                            tooltipLlmDecrease: "A decrease indicates fewer incidents in recent period.",
                            downloadChart: "Download Chart",
                            noTitle: "Main Cluster Comparison"
                        },
                        effortReductionChart: {
                            loading: "Loading effort reduction chart...",
                            noData: "No effort reduction data available",
                            title: "Effort Reduction",
                            timeToResolve: "Time to Resolve Improvements",
                            effortPerTicket: "Effort Per Ticket",
                            ttrImprovements: "TTR Improvements by Cluster",
                            improvementMetrics: "Improvement Metrics",
                            totalTicketsReduced: "Total Tickets Reduced:",
                            avgEffortSavingPerTicket: "Avg. Effort Saving Per Ticket:",
                            avgEffortSavings: "Avg. Effort Savings:",
                            totalTtrSavings: "Total TTR Savings:",
                            hours: "hours",
                            manHours: "man hours",
                            topCluster: "Top cluster:"
                        },
                        subClusterComparison: {
                            loading: "Loading comparison chart...",
                            title: "Sub-Cluster Comparison",
                            numberOfClusters: "Number of Clusters",
                            colorExplanation: "Color Explanation",
                            countLabel: "Count",
                        },
                        categoryAnalysisChart: {
                            categoryTitle: "Category",
                            loading: "Loading category analysis chart...",
                            title: "Category Analysis Comparison",
                            numberOfSubClusters: "Number of SubClusters",
                            colorExplanation: "Color Explanation",
                            countLabel: "Count"
                        },
                        analysisPredictions: {
                            loading: "Loading analysis and predictions..."
                        },
                        cmdbReport: {
                            title: "CMDB Report",
                            loading: "Loading CMDB data...",
                            subCluster: "Sub Cluster",
                            cmdbCi: "CMDB CI",
                            counts: "Counts",
                            noData: "No CMDB data available"
                        },
                        recommendedAutomationCandidates: {
                            loading: "Loading automation candidates data..."
                        },
                        report: {
                            title: "Report",
                            loading: "Loading Report Data...",
                            retry: "Retry",
                            error: "Failed to load report data. Please try again.",
                            noData: "No report data available. Click to load data.",
                            category: "Category",
                            sum: "Sum",
                            mainClusterTitle: "Main Clusters",
                            mainCluster: "Main Cluster",
                            subClusterTitle: "Sub Clusters",
                            subCluster: "Sub Cluster",
                            analysisTitle: "Analysis",
                            predictionsTitle: "Predictions",
                            download: "Download",
                            downloadMainClusterTooltip: "Download Main Clusters",
                            downloadSubClusterTooltip: "Download Sub Clusters",
                            downloadAutomationCandidatesTooltip: "Download Automation Candidates",
                            downloadCMDBTooltip: "Download CMDB Report",
                            downloadAnalysisPredictionsTooltip: "Download Analysis and Predictions",
                            downloadCMDBAnalysisTooltip: "Download CMDB Analysis"
                        }

                    },
                    "smtdReviews": {
                        "title": "SMTD review",
                        "generated": "Generated",
                        "view": "View",
                        "update": "Update",
                        "approve": "Approve",
                        "reprocess": "Regenerate",
                        "reprocessing": "Generating",
                        "reprocessWarning": "Connectors must be processed before regenerating the SMTD. Please ensure the connectors are processed before proceeding.",
                        "approved": "Approved",
                        "inReview": "In review",
                        "updateModalTitle": "Update SMTD",
                        "note": "Note",
                        "updateModalNote": "After updating the document, upload the document back.",
                        "browse": "Browse",
                        "uploadUpdatedSmtd": "Upload Updated SMTD"
                    },
                    "knowledgeArtefacts": "Knowledge Artifacts",
                    "artifacts": "Artifacts",
                    "count": "Count",
                    "artefact": {
                        "SOW": "SOW",
                        "Business Capability Map": "Business Capability Map",
                        "Application Inventory": "Application Inventory",
                        "Stakeholder Contacts": "Stakeholder Contacts",
                        "Governance Plan": "Governance Plan",
                        "Incidents": "Incidents",
                        "Service Requests": "Service Requests",
                        "Standard Operating Procedures (SOPs)": "Standard Operating Procedures (SOPs)",
                        "System Maintenance Technical Documents (SMTDs)": "System Maintenance Technical Documents (SMTDs)",
                        "Others": "Others"
                    },

                    // { id: "sopsCreated", labelKey: "sopsCreated", value: summary.sop_created, type: "single", prefixIcon: ICON_NAMES.BLUE_ARROW },
                    //     { id: "sopsIdentified", labelKey: "sopsIdentified", value: summary.sop_identified, type: "single", prefixIcon: ICON_NAMES.BLUE_ARROW },
                    //     { id: "gapCount", labelKey: "gapCount", value: summary.gap_count, type: "single", prefixIcon: ICON_NAMES.BLUE_ARROW },
                    //     { id: "unclearIssues", labelKey: "unclearIssues", value: summary.unclear_issue, type: "single", prefixIcon: ICON_NAMES.BLUE_ARROW },
                    //     { id: "smtdCount", labelKey: "smtdCount", value: summary.smtd_count, type: "single", prefixIcon: ICON_NAMES.BLUE_ARROW },
                    //     { id: "questionCount",
                    "analysisReport": "Tickets Analysis",
                    "totalIncidents": "Total Incidents:",
                    "closedIncidents": "Closed Incidents:",
                    "openIncidents": "Open Incidents:",
                    "totalSRs": "Total SRs:",
                    "closedSRs": "Closed SRs:",
                    "openSRs": "Open SRs:",
                    "priority": "Priority",
                    "p1Incidents": "P1 Incidents",
                    "p2Incidents": "P2 Incidents",
                    "p3Incidents": "P3 Incidents",
                    "otherIncidents": "Other Incidents",
                    "p1SRs": "P1 SRs",
                    "p2SRs": "P2 SRs",
                    "p3SRs": "P3 SRs",
                    "otherSRs": "Other SRs",
                    "knowledgeAssessment": "Knowledge Assessment",
                    "sopsIdentified": "SOPs Identified",
                    "sopsCreated": "SR (SOPs created)",
                    "gapCount": "Gap Count",
                    "unclearIssues": "Unclear Issues",
                    "questionCount": "Question Count",
                    "smtdCount": "SMTD Count",
                    "ktPlan": "KT Plan",
                    "ktCalendar": "KT Calendar",
                    "ktDetails": "KT Details",
                    "smtdReview": "SMTD Review",
                    "transitionClosureReadiness": "Transition Closure Readiness",
                    "applicationName": "Application1",
                    "sopList": "SOP List",
                    "invite": "Invite",
                    "invitationLog": "Invitation Log",
                    questionsGenerated: 'Questions Generated',
                    applicationSummary: 'Application Summary',
                    "role": {
                        "Infrastructure Lead": "Infrastructure Lead",
                        "Engineer": "Engineer",
                        "Admin": "Admin",
                        "Transition Manager": "Transition Manager",
                        "Transition Director": "Transition Director",
                        "SME's": "SME's",
                        "Ariba Tower Lead": "Ariba Tower Lead"
                    },
                    "status": {
                        "Invited": "Invited",
                        "In Review": "In Review",
                        "Approved": "Approved",
                        "Rejected": "Rejected",
                        "In-Progress": "In-Progress",
                        "Done": "Done",
                        "Passed": "Passed",
                        "Needs review": "Needs review"
                    },
                    "score": "Score: {{score}}%",
                    "certified": "Certified",
                    "notCertified": "Not Certified",
                    "viewDetails": "View Details",
                    "generated": "Generated: {{date}}",
                    "view": "View",
                    "approve": "Approve",
                    "approveConfirm": "Confirm Approval",
                    "approvePendingItems": "This application has pending items. Are you sure you want to approve it?",
                    "ready": "Ready",
                    "notReady": "Not Ready",
                    "sessionsCompleted": "All KT sessions completed",
                    "sessionsNotCompleted": "KT sessions not completed",
                    "itemsCompleted": "All open items completed",
                    "itemsNotCompleted": "Open items not completed",
                    "riskCarried": "Risk carried",
                    "riskNotCarried": "Risk not carried",
                    day: "Day",
                    week: "Week",
                    month: "Month",
                    scheduleMeeting: "Schedule Meeting",
                    editEvent: "Edit Event",
                    title: "Title",
                    start: "Start",
                    end: "End",
                    attendees: "Attendees",
                    color: "Event Color",
                    cancel: "Cancel",
                    create: "Create",
                    save: "Save",
                    delete: "Delete",
                    join: "Join",
                    untitled: "Untitled",
                    performAndObserve: 'Perform & Observe',
                    perform: 'Perform',
                    observe: 'Observe',
                    transitionGovernance: 'Transition Governance',
                    itManagerGovernance: 'Support Governance',
                    dashboard: 'Dashboard',
                    dashboards: "Dashboards",
                    incomplete: "InCompleted",
                    qualityPercentage: "Quality Percentage",
                    gapsIdentified: "Gaps identified",
                    recordings: "No of Recordings",


                    // top metrics
                    incidentsWithoutSOP: "Incidents without SOP",
                    serviceReqWithoutSOP: "Service req without SOP",
                    unansweredQuestions: "Un answered Questions",


                    // totals
                    totalTopics: "Total Topics",
                    totalTowers: "Total Towers",
                    totalApps: "Total Apps",


                    // incidents/service requests block
                    p1p2Incidents: "P1 & P2 Incidents",
                    openSrs: "Open SR's",
                    p1p2Srs: "P1 & P2 SR's",
                    serviceRequests: "Service Requests",
                    incidentsWithoutResolution: "Incidents w/o resolution",


                    // small metrics row
                    smtdGenerated: "SMTD Generated",
                    sopsGenerated: "SOPs Generated",
                    noOfRecordings: "Number of Recordings",
                    avgQualityScore: "Avg Quality Score",


                    // sessions / quality / completion
                    totalSessions: "Total Sessions",
                    averageQuality: "Average quality",
                    completion: "Completion",
                    passedTest: "Passed test",
                    failedTest: "Failed test",
                    underReview: "Under Review",


                    // apps status
                    appsWithoutSMTD: "Apps without SMTD",
                    completedCount: "Completed",
                    inProgress: "In Progress",
                    totalSmtds: "Total SMTDs",


                    // pending metrics
                    ktSessionsPending: "KT Sessions Pending",
                    playbackSessionsPending: "Playback Sessions Pending",
                    smtdPending: "SMTD Pending",

                    // Take Test
                    takeTest: "Take Test",
                    startExam: "Let's start the exam",
                    instructionTitle: "Instructions",
                    backToDashboard: "Back to dashboard",
                    noQuestionFound: "This assessment currently has no questions assigned.",
                    hello: "Hello",
                    nextStep: "The next step for getting certified is an online assessment. Please attend the exam and good luck.",
                    passScore: "Score",
                    duration: "Duration",
                    mark: "Mark",
                    deadline: "Deadline",
                    next: "Next",
                    prev: "Previous",
                    submit: "Submit",
                    congratulations: "Congratulations!",
                    betterLuckNextTime: 'Better luck next time!',
                    failedMessage: 'Please re attempt',
                    completedMsg: "You have successfully completed the test",
                    scoreYouHave: "You have scored",
                    passed: "Passed",
                    needsReview: "Needs review",
                    attempted: 'Attempted',
                    unAttempted: 'Un-Attempted',
                    completeAllQuestionNote: 'Please attempt all questions before submitting.',
                    reviewAnswers: 'Review answers',
                    progress: 'Progress',
                    edit: 'Edit',
                    featureInDevelopment: 'Feature In Development...',
                    generateKtTopics: 'Generate KT Topics',
                    uploadKtTopics: 'Upload KT Sessions',
                    generateKnowledgeArtifacts: 'Perform Knowledge Coverage',
                    generateLearnStatus: 'Show Learn Status',
                    learnStatus: 'Learn Status (Latest run per Connector)',
                    loading: 'Loading...',
                    generating: 'Generating...',
                    noDataAvailable: 'No data available',
                    KtTopicsDialogue: {
                        title: "Upload KT Sessions",
                        description: "Upload an CSV file.",
                        supportedFormat: "Supported formats: {{formats}}",
                        chooseFile: "Choose file",
                        upload: "Upload",
                        cancel: "Cancel",
                        close: "Close",
                        bulkUploadResults: "Upload Results",
                    },
                    uploadQuestions: 'Upload Questions',
                    questionsDialog: {
                        title: "Upload Questions",
                        description: "Upload an Excel (.xlsx/.xls) or CSV file containing questions.",
                        supportedFormat: "Supported formats: {{formats}}",
                        chooseFile: "Choose file",
                        upload: "Upload",
                        cancel: "Cancel",
                        close: "Close",
                        invalidFileType: "Invalid file type. Only .xlsx, .xls and .csv are allowed.",
                        invalidFormat: "Uploaded file doesn't match expected format.",
                        preview: "Preview",
                        noData: "No questions parsed yet.",
                        projectId: "Project ID",
                        role: "Role",
                        appid: "App ID",
                        type: "Type",
                        complexity: "Complexity",
                        question: "Question",
                        choices: "Choices",
                        answerType: "Answer Type",
                        answer: "Answer",
                        importSuccess: "File parsed successfully",
                        importFail: "File parsing failed",
                        downloadTemplate: 'Download Template',
                        downloadingTemplate: 'Downloading Template'
                    },
                },
                connectors: {
                    systemConnectors: 'System Connectors',
                    addConnector: '+ Add Connector',
                    createNewConnectors: 'Create New Connectors',
                    viewConnectors: 'View Connectors',
                    configuredConnectors: 'Configured Connectors',
                    availableConnectors: 'Available Connectors',
                    createConnector: 'Create Connector',
                    sharePoint: 'SharePoint',
                    serviceNow: 'ServiceNow',
                    googleWorkspace: 'Google Workspace',
                    addConnectorTitle: 'Add Connector',
                    connectorDetails: 'Connector Details',
                    // connectorName: 'Connector Name',
                    connectorName: 'Name',
                    connectorType: 'Type',
                    lastSync: 'Last Sync',
                    createdBy: 'Created By',
                    createdAt: 'Created On',
                    mappedProject: 'Project Mapped',
                    notMapped: 'Not mapped to project',
                    documents: 'Documents',
                    files: 'Files',
                    connected: 'Connected',
                    disconnected: 'Disconnected',
                    configure: 'Configure',
                    confirmDeleteTitle: 'Delete',
                    confirmDeleteMessage: 'Are you sure you want to delete.',
                    confirmConnectorDeleteMessage: 'Are you sure you want to delete Connector ?',
                    disconnectConfirmMessage: 'Are you sure you want to disconnect ?',
                    worklogs: 'Worklogs',
                    requiredField: 'This is required',
                    select: 'select',
                    columnName: 'Name',
                    correspondingColumnName: 'Column',
                    disconnect: 'Disconnect',
                    reconnect: 'Reconnect',
                    delete: 'Delete',
                    add: 'Add',
                    noMoreFields: 'No more fields to add',
                    levelsLabel: 'Levels',
                    fieldsLabel: 'Fields',
                    selectPlaceholder: 'Select',
                    cancel: 'Cancel',
                    configureConnector: 'Configure Connector',
                    view: 'View',
                    mappedToProject: 'Connectors Mapped to Project',
                    connectorWorkLogsTitle: 'Connector Work Logs',
                    noLevelsDataPresent: 'Please make sure that Project has Read Write Connector Processed.',
                    processDisabledReadWriteRequired: 'Processing is disabled. Please complete read/write operations for this project first.',
                    sharepointConfidentialWarning: 'Note: Confidential SharePoint sites are not allowed.',
                    updateInventoryFile: 'Update Inventory File',
                    updateApplicationInventory: 'Update Application Inventory',
                    back: 'Back',
                    next: 'Next',
                    browse: 'Browse',
                    downloadInventoryFile: 'Download Inventory File',
                    inventoryFilePlaceholder: 'File / URL for application inventory',
                },
                workLogs: {
                    noLogs: "No logs to display",
                    showingLogs: "Showing {{from}}-{{to}} of {{total}} logs"
                },
                dashboard: {
                    errorLoadingDashboard: "Error Loading Dashboard",
                    retry: "Retry"
                },
            }
        },
        fr: {
            translation: {
                // Existing keys can go here...
                COMPLETED: "Terminé",
                REQUIRED: "Requis",
                CREATED: "Créé",
                ['IN PROGRESS']: "En cours",
                common: {
                    "transitionJourney": "Parcours de transition",
                    "aiAgent": "Agent IA",
                    "wingsAlly": "WINGS Ally",
                    "projectName": "Nom du projet",
                    "dashboard": "Tableau de bord",
                    "collaboration": "Collaboration",
                    "workLog": "Journal de travail",
                    dashboardCollaboration: 'Tableau de bord-Collaboration',
                    logout: 'Déconnexion',
                    agentsInsights: 'Informations sur les agents',
                    projects: 'Projets',
                    save: 'Enregistrer',
                    cancel: 'Annuler',
                },
                "mainMenu": {
                    "dashboard": "Tableau de bord",
                    "ktPlan": "Plan KT",
                    "data": "Données",
                    "transitionJourney": "Parcours de transition",
                    "application": "Application",
                    "integration": "Intégration",
                    "infraCloud": "Infra Cloud",
                    "security": "Sécurité",
                    "network": "Réseau",
                    "businessFunctions": "Fonctions métier",
                    "itOps": "Opérations IT"
                },
                transitionJourney: {
                    overview: 'Overview',
                    prerequisites: "Configuration",
                    teamCollaboration: "Invitation d'équipe",
                    connectors: "Connectors",
                    noMembers: "Aucun membre",
                    teamCollaborationProgress: "Progression de la collaboration d'équipe",
                    teamCollaborationNotes: "Notes de collaboration d'équipe",
                    collaborationLogs: "Journaux de collaboration",
                    configureKnowledge: "Configurer la connaissance",
                    knowledgeConfigurationProgress: "Progression de la configuration des connaissances",
                    knowledgeConfigurationNotes: "Notes de configuration des connaissances",
                    configurationLogs: "Journaux de configuration",
                    autoCreateStandardDirectory: "Créer automatiquement le répertoire standard",
                    directoryCreationProgress: "Progression de la création du répertoire",
                    directoryCreationNotes: "Notes sur la création du répertoire",
                    directoryLogs: "Journaux du répertoire",

                    learn: "Apprendre",
                    deriveKnowledge: "Artefact de connaissance",
                    knowledgeDerivationProgress: "Progression de la dérivation des connaissances",
                    knowledgeDerivationNotes: "Notes de dérivation des connaissances",
                    derivationLogs: "Journaux de dérivation",
                    automatedTicketAnalysis: "Analyser et générer",
                    reviewAssessment: "Examen de l'évaluation",
                    ticketAnalysisProgress: "Progression de l'analyse des tickets",
                    ticketAnalysisNotes: "Notes sur l'analyse des tickets",
                    analysisLogs: "Journaux d'analyse",
                    autoCreateAdditionalFolder: "Créer automatiquement un dossier supplémentaire",
                    folderCreationProgress: "Progression de la création du dossier",
                    folderCreationNotes: "Notes sur la création du dossier",
                    creationLogs: "Journaux de création",
                    generateDetailedQuestionnaire: "Générer un questionnaire détaillé",
                    questionnaireGenerationProgress: "Progression de la génération du questionnaire",
                    questionnaireNotes: "Notes sur le questionnaire",
                    generationLogs: "Journaux de génération",

                    knowledgeWorkflow: "Flux de travail de connaissance",
                    knowledgeCoverageAssessment: "Évaluation de la couverture des connaissances",
                    sopGeneration: "Génération de SOP",
                    sopGenerationProgress: "Progression de la génération de SOP",
                    sopGenerationNotes: "Notes sur la génération de SOP",
                    serviceRequestGeneration: "Génération de demandes de service",
                    serviceRequestGenerationProgress: "Progression de la génération de demandes de service",
                    serviceRequestNotes: "Notes sur la demande de service",
                    requestLogs: "Journaux de demande",
                    identifyGaps: "Identifier les lacunes",
                    gapIdentificationProgress: "Progression de l'identification des lacunes",
                    gapIdentificationNotes: "Notes sur l'identification des lacunes",
                    identificationLogs: "Journaux d'identification",
                    knowledgeTransitionPlan: "Plan de transition des connaissances",
                    generatingQuestions: "Génération de questions",
                    questionGenerationProgress: "Progression de la génération de questions",
                    questionGenerationNotes: "Notes sur la génération de questions",
                    generatingKtPlan: "Génération du plan KT",
                    ktPlanGenerationProgress: "Progression de la génération du plan KT",
                    ktPlanGenerationNotes: "Notes sur la génération du plan KT",
                    reviewKtPlan: "Sujets de transfert de connaissances",
                    ktPlanReviewProgress: "Progression de la revue du plan KT",
                    ktPlanReviewNotes: "Notes sur la revue du plan KT",
                    reviewLogs: "Journaux de revue",
                    publishKtPlan: "Publier le plan KT",
                    ktPlanPublishingProgress: "Progression de la publication du plan KT",
                    ktPlanPublishingNotes: "Notes sur la publication du plan KT",
                    publishingLogs: "Journaux de publication",
                    schedulingKtSession: "Planification le plan KT",
                    ktSessionSchedulingProgress: "Progression de la planification de la session KT",
                    ktSessionSchedulingNotes: "Notes sur la planification de la session KT",
                    schedulingLogs: "Journaux de planification",

                    ktSession: "Session KT",
                    ktSessions: "Sessions KT",
                    updateKtSession: "Mettre à jour la session KT",
                    addKtSession: "Ajouter une session KT",
                    updatePlaybackSession: "Mettre à jour la session de lecture",
                    addPlaybackSession: "Ajouter une session de lecture",
                    add: "Ajouter",
                    ktStatus: 'Statut de la TA',
                    ktReview: 'Revue de la TA',
                    ktSessionMessages: {
                        descriptionRequired: 'La description est requise',
                        videoPathRequired: 'Le chemin vidéo est requis',
                        statusRequired: 'Le statut est requis',
                        projectIdMissing: 'ID de projet manquant. Impossible de {{action}} la session KT.',
                        updateSuccess: 'Session KT mise à jour avec succès',
                        addSuccess: 'Session KT ajoutée avec succès',
                        updateError: 'Erreur lors de la mise à jour de la session KT',
                        addError: 'Erreur lors de l\'ajout de la session KT',
                        videoPathRequiredForCompleted: 'Pour un statut terminé, le chemin vidéo KT doit être mis à jour avec le nouveau chemin d\'enregistrement',
                        descriptionPlaceholder: 'Entrez la description de la session',
                        videoPathPlaceholder: 'Entrez l\'URL du chemin vidéo',
                        descriptionHelperText: 'Fournissez une description détaillée de la session KT',
                        videoPathHelperText: 'Entrez le chemin complet ou l\'URL vers la vidéo de session KT'
                    },
                    processKtVideo: "Traitement de la vidéo KT",
                    ktVideoProcessingProgress: "Progression du traitement de la vidéo KT",
                    ktVideoProcessingNotes: "Notes sur le traitement de la vidéo KT",
                    processingLogs: "Journaux de traitement",
                    prepareDocument: "Préparer le document",
                    documentPreparationProgress: "Progression de la préparation du document",
                    documentPreparationNotes: "Notes sur la préparation du document",
                    preparationLogs: "Journaux de préparation",
                    performQualityCheck: "Effectuer le contrôle qualité",
                    qualityCheckProgress: "Progression du contrôle qualité",
                    qualityCheckNotes: "Notes sur le contrôle qualité",
                    qualityCheckLogs: "Journaux de contrôle qualité",
                    generateSopDocument: "Générer le document SOP",
                    sopDocumentGenerationProgress: "Progression de la génération du document SOP",
                    sopDocumentNotes: "Notes sur le document SOP",
                    sopDocumentLogs: "Journaux du document SOP",
                    playback: "Lecture",
                    playbackSessions: "Sessions de lecture",
                    playbackAssessment: "Évaluation de lecture",
                    takeTest: "Passer le test",
                    reverseKtSession: "Session KT inverse",
                    processReverseKtVideo: "Traitement de la vidéo KT inverse",
                    reverseKtVideoProcessingProgress: "Progression du traitement de la vidéo KT inverse",
                    reverseKtVideoNotes: "Notes sur la vidéo KT inverse",
                    generateMcq: "Générer un QCM",
                    mcqGenerationProgress: "Progression de la génération du QCM",
                    mcqGenerationNotes: "Notes sur la génération du QCM",
                    shareCertificationToCustomer: "Partager la certification au client",
                    certificationSharingProgress: "Progression du partage de la certification",
                    certificationSharingNotes: "Notes sur le partage de la certification",
                    sharingLogs: "Journaux de partage",
                    reverseKtToCustomer: "KT inverse au client",
                    reverseKtToCustomerProgress: "Progression du KT inverse au client",
                    reverseKtToCustomerNotes: "Notes sur le KT inverse au client",
                    reverseKtLogs: "Journaux KT inverse",

                    smtdGeneration: "Génération SMTD",
                    generateSmtd: "Générer SMTD",
                    smtdGenerationProgress: "Progression de la génération SMTD",
                    smtdGenerationNotes: "Notes sur la génération SMTD",
                    reviewSmtd: "SMTD Revoir",
                    smtdReviewProgress: "Progression de la revue SMTD",
                    smtdReviewNotes: "Notes sur la revue SMTD",

                    transitionClosure: "Clôture de transition",
                    transitionStatusReport: "Rapport d'état de transition",
                    transitionReview: "Revue de transition",
                    transitionStatusReportProgress: "Progression du rapport d'état de transition",
                    transitionStatusReportNotes: "Notes sur le rapport d'état de transition",
                    reportLogs: "Journaux de rapport",
                    closureAndSignOff: "Clôture et validation",
                    closureAndSignOffProgress: "Progression de la clôture et validation",
                    closureAndSignOffNotes: "Notes sur la clôture et validation",
                    closureLogs: "Journaux de clôture",

                    description: 'Description',
                    videoPath: 'Chemin vidéo',
                    viewStatus: 'Statut',
                    overallStatus: 'État global',
                    updateStatus: 'Mettre à jour le statut',
                    source: 'Source',
                    updatedAt: 'Mis à jour le',
                    play: 'Lire',

                    createProject: 'Créer un projet',
                    projectDetails: 'Détails du projet',
                    inviteMember: 'Inviter un membre',
                    searchName: 'Rechercher un nom ici',
                    projectName: 'Nom du projet',
                    projectDescription: 'Description du projet',
                    projectStartDate: 'Date de début du projet',
                    projectEndDate: 'Date de fin du projet',
                    projectPlanUpload: 'Télécharger le plan du projet',
                    value: 'Valeur',
                    activeAgentTasks: "Tâches Actives des Agents",
                    workflowLogs: "Journaux de Workflow",
                    createNewProject: 'Créer un nouveau projet',
                    projectNameRequired: "Nom du projet requis",
                    projectDescriptionRequired: "Description du projet requise",
                    projectStartDateRequired: "Date de début du projet requise",
                    projectEndDateRequired: "Date de fin du projet requise",
                    endDateAfterStartDate: "La date de fin du projet doit être postérieure à la date de début",
                    projectPlanRequired: 'Le plan de projet est requis',
                    "search": "Chercher",
                    "addUser": "Ajouter un utilisateur",
                    "newMembers": "Nouveaux membres",
                    "existingMembers": "Membres existants",
                    "listOfProjects": "Liste des projets",
                    "members": "Membres",
                    "addMore": "Ajouter plus",
                    "addMembers": "Ajouter Membres",
                    "noProjectPlanUploaded": "Aucun plan de projet téléchargé",
                    "noProcessedConnector": "La transition (traitement des données) n'est pas encore initiée.",
                    "process": "Traiter",
                    "reprocess": "Retraiter",
                    "teamInvite": {
                        "title": "Invitation d'équipe",
                        "subtitle": "Inviter les membres de l'équipe à collaborer",
                        "searchPlaceholder": "Rechercher des utilisateurs par email ou rôle...",
                        "addNewUser": "Ajouter un nouvel utilisateur",
                        "uploadFromFile": "Télécharger depuis un fichier",
                        "addUserButton": "Ajouter un utilisateur",
                        "bulkUploadButton": "Téléchargement en masse",
                        "newMembers": "Nouveaux membres",
                        "existingTeamMembers": "Membres d'équipe existants",
                        "noNewMembers": "Aucun nouveau membre ajouté pour le moment",
                        "noNewMembersDescription": "Commencez par ajouter des membres d'équipe pour commencer la collaboration",
                        "noExistingMembers": "Aucun membre existant",
                        "removeMember": "Supprimer le membre",
                        "addMember": "Ajouter un membre",
                        "alreadyAdded": "Déjà ajouté",
                        "role": "Rôle",
                        "noUsersFound": "Aucun utilisateur trouvé pour '{{searchTerm}}'",
                        "confirmRemoveTitle": "Supprimer le membre de l'équipe",
                        "confirmRemoveMessage": "Êtes-vous sûr de vouloir supprimer",
                        "confirmRemoveSubtext": "Cette action ne peut pas être annulée.",
                        "removeConfirmationWarning": "Cette action ne peut pas être annulée.",
                        "memberWillLoseAccessSelectedRoles": "Le membre perdra l'accès aux ressources pour les rôles sélectionnés.",
                        "memberWillLoseAccessAllResources": "Le membre perdra l'accès à toutes les ressources de l'équipe.",
                        "selectRolesToRemove": "Sélectionner les rôles à supprimer",
                        "hasMultipleRolesSelectToRemove": "a plusieurs rôles. Sélectionnez les rôles à supprimer :",
                        "cancel": "Annuler",
                        "remove": "Supprimer",
                        "selectAll": "Select All",
                        "selectPersona": "Select Persona",
                    },
                    "knowledgeArtefacts": "Artefacts de connaissance",
                    "artefact": {
                        "SOW": "Énoncé de travail",
                        "Business capability map": "Carte des capacités commerciales",
                        "Application Inventory": "Inventaire des applications",
                        "Stakeholder Contacts": "Contacts des parties prenantes",
                        "Governance plan": "Plan de gouvernance",
                        "Incidents": "Incidents",
                        "Service Requests": "Demandes de service",
                        "Standard operating procedures": "Procédures opérationnelles standard",
                        "Business Capability Map": "Business Capability Map",
                        "No of SMTDs": "No of SMTDs",
                        "No of SoPs": "No of SoPs",
                    },
                    "analysisReport": "Rapport d'analyse",
                    "totalIncidents": "Incidents totaux:",
                    "closedIncidents": "Incidents fermés:",
                    "openIncidents": "Incidents ouverts: ",
                    "totalSRs": "SRs totaux:",
                    "closedSRs": "SRs fermés:",
                    "openSRs": "SRs ouverts:",
                    "priority": "Priorité",
                    "p1Incidents": "Incidents P1",
                    "p2Incidents": "Incidents P2",
                    "p3Incidents": "Incidents P3",
                    "otherIncidents": "Autres incidents",
                    "p1SRs": "SR P1",
                    "p2SRs": "SR P2",
                    "p3SRs": "SR P3",
                    "otherSRs": "Autres SR",
                    "knowledgeAssessment": "Évaluation des connaissances",
                    "sopsIdentified": "SOPs identifiés:",
                    "sopsCreated": "SRs créés:",
                    "gapCount": "Nombre de lacunes:",
                    "unclearIssues": "Problèmes non clairs:",
                    "questionCount": "Nombre de questions:",
                    smtdCount: "nombre de CMS",
                    "ktPlan": "Plan KT",
                    "ktCalendar": "Calendrier KT",
                    "ktDetails": "Détails KT",
                    "smtdReview": "Revue SMTD",
                    "transitionClosureReadiness": "Préparation à la clôture de la transition",
                    "applicationName": "Application1",
                    "sopList": "Liste SOP",
                    "invite": "Inviter",
                    "invitationLog": "Journal des invitations",
                    questionsGenerated: 'Questions générées',
                    applicationSummary: 'Application Summary',
                    "role": {
                        "Infrastructure Lead": "Chef d'infrastructure",
                        "Engineer": "Ingénieur",
                        "Admin": "Administrateur",
                        "Transition Manager": "Responsable de transition",
                        "SME's": "PME",
                        "Ariba Tower Lead": "Chef de la tour Ariba",
                        "Transition Director": "Directeur de transition",
                    },
                    "status": {
                        "Invited": "Invité",
                        "In Review": "En révision",
                        "Approved": "Approuvé",
                        "Rejected": "Rejeté",
                        "In-Progress": "En cours",
                        "Done": "Fait",
                        "Passed": "Réussi",
                        "Needs review": "Besoin de révision"
                    },
                    "score": "Score: {{score}}%",
                    "certified": "Certifié",
                    "notCertified": "Non certifié",
                    "viewDetails": "Voir les détails",
                    "generated": "Généré: {{date}}",
                    "view": "Voir",
                    "approve": "Approuver",
                    "approveConfirm": "Confirmer l'approbation",
                    "approvePendingItems": "Cette application a des éléments en attente. Êtes-vous sûr de vouloir l'approuver ?",
                    "ready": "Prêt",
                    "notReady": "Pas prêt",
                    "sessionsCompleted": "Toutes les sessions KT terminées",
                    "sessionsNotCompleted": "Sessions KT non terminées",
                    "itemsCompleted": "Tous les éléments ouverts terminés",
                    "itemsNotCompleted": "Éléments ouverts non terminés",
                    "riskCarried": "Risque porté",
                    "riskNotCarried": "Risque non porté",
                    day: "Jour",
                    week: "Semaine",
                    month: "Mois",
                    scheduleMeeting: "Planifier une réunion",
                    editEvent: "Modifier l’événement",
                    title: "Titre",
                    start: "Début",
                    end: "Fin",
                    attendees: "Participants",
                    color: "Couleur de l’événement",
                    cancel: "Annuler",
                    create: "Créer",
                    update: "Mettre à jour",
                    save: "Enregistrer",
                    delete: "Supprimer",
                    join: "Rejoindre",
                    untitled: "Sans titre",
                    performAndObserve: 'Effectuer et Observer',
                    perform: 'effectuer',
                    observe: 'observer',
                    transitionGovernance: 'Gouvernance de Transition',
                    dashboard: "Tableau de Bord",
                    totalSmtds: "Total des SMTD",
                    startExam: "Commençons l'examen",
                    instructionTitle: "Instructions",
                    backToDashboard: "Retour au tableau de bord",
                    hello: "Bonjour",
                    nextStep: "La prochaine étape pour obtenir la certification est une évaluation en ligne. Veuillez passer l'examen et bonne chance.",
                    passScore: "Score",
                    duration: "Durée",
                    mark: "Note",
                    deadline: "Date limite",
                    next: "Suivant",
                    prev: "Précédent",
                    submit: "Soumettre",
                    congratulations: "Félicitations !",
                    completedMsg: "Vous avez terminé le test avec succès",
                    failedMessage: '',
                    scoreYouHave: "Vous avez obtenu",
                    passed: "Réussi",
                    needsReview: "Doit être révisé",
                    featureInDevelopment: 'Fonctionnalité en développement...',
                    generateKtTopics: 'Générer des sujets KT',
                    generating: 'Génération...'
                },
                connectors: {
                    systemConnectors: 'Connecteurs système',
                    addConnector: '+ Ajouter un connecteur',
                    createNewConnectors: 'Créer de nouveaux connecteurs',
                    viewConnectors: 'Voir les connecteurs',
                    configuredConnectors: 'Connecteurs configurés',
                    createConnector: 'Créer un connecteur',
                    sharePoint: 'SharePoint',
                    serviceNow: 'ServiceNow',
                    googleWorkspace: 'Google Workspace',
                    addConnectorTitle: 'Ajouter un connecteur',
                    connectorDetails: 'Détails du connecteur',
                    connectorName: 'Nom',
                    lastSync: 'Dernière synchronisation',
                    documents: 'Documents',
                    files: 'Fichiers',
                    connected: 'Connecté',
                    disconnected: 'Déconnecté',
                    configure: 'Configurer',
                    worklogs: 'Journaux de travail',
                    disconnect: 'Déconnecter',
                    reconnect: 'Reconnecter',
                    delete: 'Supprimer',
                    add: 'Ajouter',
                    noMoreFields: 'Aucun autre champ à ajouter',
                    levelsLabel: 'Niveaux',
                    fieldsLabel: 'Champs',
                    selectPlaceholder: 'Sélectionner',
                    cancel: 'Annuler',
                    configureConnector: 'Configurer le connecteur',
                    requiredField: 'Ceci est requis',
                    select: 'sélectionner',
                    columnName: 'Nom',
                    correspondingColumnName: 'Colonne',
                    confirmDeleteTitle: 'Supprimer',
                    confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer.',
                    connectorType: 'Type',
                    view: 'Voir',
                    mappedToProject: 'Connecteurs Mappés au Projet',
                    connectorWorkLogsTitle: 'Journaux de travail du connecteur',
                    noLevelsDataPresent: 'Veuillez vous assurer que le projet a un connecteur de lecture-écriture traité.',
                    processDisabledReadWriteRequired: 'Le traitement est désactivé. Veuillez d\'abord terminer les opérations de lecture/écriture pour ce projet.',
                    sharepointConfidentialWarning: 'Note: Les sites SharePoint confidentiels ne sont pas autorisés.',
                },
                dashboard: {
                    errorLoadingDashboard: "Erreur de chargement du tableau de bord",
                    retry: "Réessayer"
                },
            }
        }
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
